// Pins are a browser preference, not a filter value.
// Nothing is stored until the user pins or unpins on that table.
// Until then the table shows its first three filters. There is no expiry:
// the entry stays until the user clears browser data.

const STORAGE_PREFIX = "cap_pinned_filters";

const storageKey = (userEmail, tableId) => `${STORAGE_PREFIX}:${userEmail}:${tableId}`;

const readRaw = (userEmail, tableId) => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return null;
  }
  try {
    return window.localStorage.getItem(storageKey(userEmail, tableId));
  } catch (err) {
    return null;
  }
};

/**
 * Saved pin keys for this user and table, or null when the user has never
 * changed pins here. Null means "use the first three enabled filters".
 * An empty array means the user unpinned everything on purpose.
 */
export const readPinnedFilterKeys = (userEmail, tableId) => {
  const raw = readRaw(userEmail, tableId);
  if (raw === null || raw === "") {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.customized !== true || !Array.isArray(parsed.keys)) {
      return null;
    }
    return parsed.keys.filter((key) => typeof key === "string");
  } catch (err) {
    return null;
  }
};

export const writePinnedFilterKeys = (userEmail, tableId, keys) => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(
      storageKey(userEmail, tableId),
      JSON.stringify({ customized: true, keys })
    );
  } catch (err) {
    // A full or blocked localStorage should not stop filtering.
  }
};
